<template>
  <div id="keypadnum" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <input type="text" ref="keypadInput" v-model="inputValue" readonly>
        </div>
        
        <div class="modal-body1 d-flex flex-row w-100 justify-content-between">
          <div>
            <div class="d-flex flex-row">
              <div class="num" @click="appendNumber(1)">1</div>
              <div class="num" @click="appendNumber(2)">2</div>
              <div class="num" @click="appendNumber(3)">3</div>
            </div>
            <div class="d-flex flex-row">
              <div class="num" @click="appendNumber(4)">4</div>
              <div class="num" @click="appendNumber(5)">5</div>
              <div class="num" @click="appendNumber(6)">6</div>
            </div>
            <div class="d-flex flex-row">
              <div class="num" @click="appendNumber(7)">7</div>
              <div class="num" @click="appendNumber(8)">8</div>
              <div class="num" @click="appendNumber(9)">9</div>
            </div>
            <div class="d-flex flex-row">
              <div class="num" style="width: -webkit-fill-available;" @click="appendNumber(0)">0</div>
              <div class="num" @click="appendDecimal()">.</div>
            </div>
          </div>
          <div>
            <div class="back btnk" @click="backspace()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M9.375 233.4l128-128c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H480c17.69 0 32 14.31 32 32s-14.31 32-32 32H109.3l73.38 73.38c12.5 12.5 12.5 32.75 0 45.25c-12.49 12.49-32.74 12.51-45.25 0l-128-128C-3.125 266.1-3.125 245.9 9.375 233.4z"/>
              </svg>
            </div>
            <div class="clear btnk" @click="clear()">CLEAR</div>
            <div class="cancel btnk" @click="cancel()">CANCEL</div>
            <div class="done btnk" @click="done()">DONE</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'NumericKeypad',
  emits: ['update:value', 'cancel'],  // Declare emitted events
  data() {
    return {
      inputValue: '',
      modal: null
    }
  },
  mounted() {
    this.modal = new Modal(this.$el);
  },
  methods: {
     setTargetInput(inputRef) {
      this.targetInput = inputRef;
    },
    show() {
      this.modal.show();
    },
    hide() {
      this.modal.hide();
      this.removeBackdrop();
    },
    appendNumber(num) {
      this.inputValue += num.toString();
    },
    appendDecimal() {
      // Only add decimal point if there isn't one already
      if (this.inputValue.indexOf('.') === -1) {
        // If empty, add '0.' instead of just '.'
        if (this.inputValue === '') {
          this.inputValue = '0.';
        } else {
          this.inputValue += '.';
        }
      }
    },
    backspace() {
      this.inputValue = this.inputValue.slice(0, -1);
    },
    clear() {
      this.inputValue = '';
    },
    removeBackdrop() {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      document.body.classList.remove('modal-open');
      document.body.style.paddingRight = '';
    },
    cancel() {
      this.hide();
      this.$emit('cancel');
    },
    done() {
      this.$emit('input', this.inputValue); 
      this.$emit('update:value', this.inputValue); 
      this.hide();
    }
  }
}
</script>